import { render } from "./ClientDialog.vue?vue&type=template&id=0c96d45c&scoped=true"
import script from "./ClientDialog.vue?vue&type=script&lang=js"
export * from "./ClientDialog.vue?vue&type=script&lang=js"

import "./ClientDialog.vue?vue&type=style&index=0&id=0c96d45c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c96d45c"]])

export default __exports__